import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty} from 'class-validator';
import {ApiProperty} from '@nestjs/swagger';

export class EmploymentStatDTO{
    @ApiProperty()
    @IsNotEmpty({message: 'Employment Status Id should not be empty'})
    @IsAlphanumeric()
    @IsOptional()
    employmentStatusId: number;

    @IsNotEmpty({message: 'Employment Status should not be empty'})
    employmentStatus: string;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: "Created User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Updated User should be only alphabets"})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

}